module.exports = __webpack_public_path__ + "static/media/nosotros.69734e5b.jpg";